﻿<!-- <div class="container-fluid page-body-wrapper full-page-wrapper" *ngIf="!demo" >
    <div class="row w-100 mx-0">
        <div class="col-lg-4 mx-auto">
            <div class="auth-form-light text-left py-5 px-4 px-sm-5 shadow p-3 mb-5 bg-white rounded-lg">
                <div class="row justify-content-center align-items-center">
                        <div class="logo" style="width:90px;height:90px;"></div>
                </div>
                <div class="row  justify-content-center align-items-center">
                    <div class="text-center text-facebook">
                        <h3>โปรแกรมแผนที่ภาษีและทะเบียนทรัพย์สิน <br>LTax3000</h3>
                    </div>
                </div>
                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="pt-3">
                    <div class="form-group">
                        <input type="username" class="form-control left-color-green" style="background-color: azure;" pattern="[a-z0-9*]*"
                            oninput="this.value = this.value.toLowerCase()" placeholder="ยูสเซอร์เนม"
                            formControlName="username" [ngClass]="{ 'is-invalid': submitted && f.username.errors }">
                    </div>
                    <div class="form-group">
                        <input type="password" style="background-color: azure;" class="form-control  left-color-green"
                            placeholder="รหัสผ่าน" formControlName="password"
                            [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                    </div>
                    <div class="mt-3">
                        <button [disabled]="loading" class="btn btn-block btn-success btn-lg font-weight-medium">
                             <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
                            เข้าสู่ระบบ</button>
                    </div>
                    <div class="text-center mt-4 font-weight-light text-facebook" style="font-size:0.7rem;">
                        ส่วนนโยบายการคลังและพัฒนารายได้ สำนักบริหารการคลังท้องถิ่น
                        <br>
                        สงวนลิขสิทธิ์ ๒๕๖๓ กรมส่งเสริมการปกครองท้องถิ่น
                    </div>
                </form>
            </div>
        </div>
    </div>
</div> -->
<!-- demo mode -->
<style>
.no-pdd-horizon {
    padding-left: 0 !important;
    padding-right: 0 !important;
}
.no-mrg-horizon {
    margin-left: 0 !important;
    margin-right: 0 !important;
}
.d-md-block {
    display: block !important;
}



.div-bg {
  background-position: 20% 100%;
  background-repeat: no-repeat;
  background-size: contain;
  animation: animateSectionBackground infinite 30s;
}

@keyframes animateSectionBackground {
    0%,24% {background-image: url("/assets/images/400.jpg");}
   25%,50% {background-image: url("/assets/images/300.jpg");}
   51%,75% {background-image: url("/assets/images/500.jpg");}
   76%,100% {background-image: url("/assets/images/700.jpg");}
   /* 100% {background-image: url("/assets/images/700.jpg");} */
}

</style>

<form [formGroup]="loginForm" (ngSubmit)="onSubmit()" >
    <div class="authentication div-bg" style="min-height: 100vh;background-repeat: no-repeat;background-size: cover;background-position: center center;">
        <div class="sign-in">
            <div class="row no-mrg-horizon">
                <div class="col-md-8 no-pdd-horizon d-md-block">
                    <div>
                        <div class="img-caption">
                            <!-- <h1 class="caption-title" style="color:tomato;">LTax3000 ภาษีที่ดินและสิ่งปลูกสร้าง</h1> -->
                            <p class="caption-text"><br><br><br><br></p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 no-pdd-horizon">
                    <div class="full-height height-100">
                    <!-- <div class="full-height height-100" style="background-color: rgba(255, 255, 255, 0.9);"> -->
                        <div class="vertical-align full-height pdd-horizon-70">
                            <div class="table-cell">
                                <div class="pdd-horizon-15 rounded p-5 shadow" style="background-color: rgba(255, 255, 255, 0.93);">
                                    <h1 style="color:green;font-size:30px;" class="text-shadow">เข้าสู่ระบบ</h1>                                                         
                                    <h3 class="text-shadow" style="color:green;">LTax ภาษีที่ดินและสิ่งปลูกสร้าง</h3>
                                    <hr />
                                        <div class="form-group">
                                            <input type="username" 
                                            class="form-control col-xs-12 col-md-12 col-lg-12"
                                            style="background-color: azure;" 
                                            pattern="[a-z0-9*]*"
                                            oninput="this.value = this.value.toLowerCase()"
                                            placeholder="ยูสเซอร์เนม" formControlName="username" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" >
                                        </div>
                                        <div class="form-group">
                                            <input type="password" style="background-color: azure;" 
                                            class="form-control col-xs-12 col-md-12 col-lg-12" placeholder="รหัสผ่าน" formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                                        </div>
                                    <button [disabled]="loading" class="btn btn-primary"><i class="fa fa-spinner fa-spin" *ngIf="loading"></i> เข้าสู่ระบบ</button>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>